import { Injectable, inject } from '@angular/core';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class PartnerGuard {
  private readonly user_service = inject(UserService);

  canActivate(): boolean {
    return this.user_service.getCurrentUser()?.role?.slug === 'partner';
  }
}
